import React, { Component } from "react";
import { is } from "immutable";
import Request from "superagent";

import { API_BASE } from "./api";
import appHistory from "./appHistory";
import GrassPage from "./GrassPage";
import PlayerList from "./PlayerList";
import SquaresTable from "./SquaresTable";
import withLivePicks from "./withLivePicks";
import { LINK_STYLE } from "./styles";

const RESET_STYLE = {
  color: "gray",
};

function randInd(n) {
  // [0, n)
  return Math.floor(Math.random() * n);
}

window.genFakePicks = () => {
  const picker = window._currentPicker;
  if (!picker) {
    console.log("No _currentPicker");
    return;
  }
  const picks = picker.props.picks;
  if (!picks.players || picks.players.size === 0) {
    console.log("Must add players to generate with");
    return;
  }

  const playersSeq = picks.players.valueSeq();
  for (let i = 0; i < 10; i++) {
    for (let j = 0; j < 10; j++) {
      if (picks.getPlayer(i, j)) {
        continue;
      }
      const player = playersSeq.get(randInd(playersSeq.size));
      const data = {
        row: i,
        col: j,
        shortName: player.shortName,
        longName: player.longName,
      };
      Request.post(`${API_BASE}/lobby/${picker.props.lobbyCode}/picks`)
        .send(data)
        .end((err, res) => {
          if (err) {
            console.log("genFakePicks error=", err);
          }
        });
    }
  }
};

// TODO handle already started game

class Picker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: null,
      saving: false,
    };
  }

  componentDidMount() {
    // HACK: FOR DEBUGGING!
    window._currentPicker = this;
  }

  componentWillUnmount() {
    window._currentPicker = null;
  }

  selectPlayer = (player) => {
    this.setState({
      selected: player,
    });
  };

  deselectPlayer = () => {
    this.setState({ selected: null });
  };

  onClickCell = (row, col) => {
    const { lobbyCode, picks } = this.props;
    const { selected: player } = this.state;
    if (!player) {
      return;
    }
    const playerAtCell = picks.getPlayer(row, col);
    const data = {
      row,
      col,
      shortName: player.shortName,
      longName: player.longName,
    };

    if (!playerAtCell) {
      Request.post(`${API_BASE}/lobby/${lobbyCode}/picks`)
        .send(data)
        .end(this.handlePickRes);
    } else if (is(playerAtCell, player)) {
      Request.delete(`${API_BASE}/lobby/${lobbyCode}/picks`)
        .send(data)
        .end(this.handlePickRes);
    }
  };

  handlePickRes = (err, res) => {
    if (err || !res.body.success) {
      console.log("add pick error", err, res.body);
    }
  };

  startGame = (e) => {
    e.preventDefault();

    if (this.startInFligth) {
      return;
    }
    const { lobbyCode } = this.props;
    this.startInFligth = true;
    Request.post(`${API_BASE}/lobby/${lobbyCode}/start`)
      .send()
      .end((err, res) => {
        this.startInFligth = false;
        if (err || (!res.body.success && res.body.errName !== "LOCKED_LOBBY")) {
          alert("Error starting game. Please try again.");
          console.log("Start error", err, res.body);
          return;
        }
        appHistory.push(`/g/${lobbyCode}`);
      });
  };

  onReset = (e) => {
    e.preventDefault();
    if (
      !window.confirm("Are you sure you want to reset? This will delete all players and the grid.")
    ) {
      return;
    }
    const { lobbyCode } = this.props;
    Request.post(`${API_BASE}/lobby/${lobbyCode}/reset`)
      .send()
      .end(this.handlePickRes);
  };

  copyLink = (e) => {
    e.preventDefault();
    navigator.clipboard.writeText(this.mobileLink());
  };

  mobileLink() {
    return `${window.location.origin}/m/${this.props.lobbyCode}`;
  }

  render() {
    const { picks } = this.props;
    const { selected } = this.state;

    let beginDiv = null;
    if (picks.total === 100) {
      beginDiv = (
        <div style={{ marginTop: 0 }}>
          <a href="/action/start-game" onClick={this.startGame} className="ulh" style={LINK_STYLE}>
            begin
          </a>
        </div>
      );
    }

    return (
      <GrassPage>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            margin: "30px auto",
            maxWidth: 900,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              paddingBottom: 30,
            }}
          >
            <PlayerList
              lobbyCode={this.props.lobbyCode}
              players={picks.players}
              onClickPlayer={this.selectPlayer}
              addPlayer={this.selectPlayer}
              deselectPlayer={this.deselectPlayer}
              selected={this.state.selected}
              picks={picks}
            />
            {beginDiv}
            <div>
              <img
                src={`/api/qr/${this.props.lobbyCode}`}
                height={256}
                width={256}
                alt="QR Code"
                title="Scan this code to make your picks from a mobile device"
              />
              <div style={{ paddingLeft: 40, marginTop: -20 }}>
                <a href={this.mobileLink()} title="click to copy" onClick={this.copyLink}>
                  Copy link to share
                </a>
              </div>
            </div>
          </div>
          <div>
            <SquaresTable
              onClickCell={this.onClickCell}
              picks={picks}
              selectedPlayer={selected}
              fadeDisabledCells
            />
            <div style={{ marginTop: 20, textAlign: "right", fontSize: "0.8em" }}>
              <a href="/action/reset" onClick={this.onReset} className="ulh" style={RESET_STYLE}>
                reset game
              </a>
            </div>
          </div>
        </div>
      </GrassPage>
    );
  }
}

export default withLivePicks(Picker);



// WEBPACK FOOTER //
// ./src/Picker.js